import React, { useRef, useState, useEffect } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import DetailsTab from './TabDetails';
import BidsTab from './TabBids';
import HistoryTab from './TabHistory';
import OwnserTab from './TabOwner';
import MusicTab from './TabMusic';
import AudioPlayer from './AudioPlayer';

export default function TabsComponent(props) {
  const classes = useStyles();
  let audioInstance = useRef(null);
  const [value, setValue] = useState(0);
  const [audioPlaying, setaudioPlaying] = useState(false);
  const [audioIndex, setaudioIndex] = useState(0);
  const [audioPlayerMode, setaudioPlayerMode] = useState('mini');
  const [showMusicTab, setshowMusicTab] = useState(false);

  console.log('props.isAdmin', props.isAdmin);
  useEffect(() => {
    if (props.nftData && props.nftData.nftType === 'Audio') {
      if (
        props.userDataRedux &&
        props.userDataRedux.uid &&
        ((props.nftData.isMultiple &&
          props.nftData.usersId &&
          props.nftData.usersId.includes(props.userDataRedux.uid)) ||
          (!props.nftData.isMultiple &&
            props.nftData.userId === props.userDataRedux.uid))
      ) {
        setshowMusicTab(true);
      } else if (props.isAdmin) {
        setshowMusicTab(true);
      }
    }

    //admin check
  }, [props.userDataRedux, props.nftData, props.isAdmin]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div className="w-full mb-6">
        <div className="pt-1">
          <div className={classes.root}>
            <AntTabs
              value={value}
              onChange={handleChange}
              aria-label="ant example"
              variant="scrollable"
              scrollButtons="auto"
              // centered
              className="asset__tabs"
            >
              <AntTab label="Owners" />
              <AntTab label="Details" />
              {props.nftData && props.nftData.nftType === 'Audio' && (
                <AntTab label="Music" />
              )}
              {props.nftData && props.nftData.nftSaleType === 'Auctioning' && (
                <AntTab label="Bids" />
              )}
              <AntTab label="History" />
            </AntTabs>
          </div>
        </div>
        <div className="bg-white flex-auto">
          <TabPanel value={value} index={0}>
            <OwnserTab
              nftData={props.nftData}
              setnftData={props.setnftData}
              setcheckoutUserName={props.setcheckoutUserName}
              checkoutUserName={props.checkoutUserName}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <DetailsTab nftData={props.nftData} />
          </TabPanel>

          {props.nftData && props.nftData.nftType === 'Audio' && (
            <TabPanel value={value} index={2}>
              <MusicTab
                nftData={props.nftData}
                audioInstance={audioInstance}
                audioPlaying={audioPlaying}
                audioIndex={audioIndex}
                setaudioPlayerMode={setaudioPlayerMode}
                setaudioPlaying={setaudioPlaying}
                showMusicTab={showMusicTab}
              />
            </TabPanel>
          )}

          {props.nftData && props.nftData.nftSaleType === 'Auctioning' && (
            <TabPanel
              value={value}
              index={props.nftData && props.nftData.nftType === 'Audio' ? 3 : 2}
            >
              <BidsTab nftData={props.nftData} isMultiple={props.isMultiple} />
            </TabPanel>
          )}

          <TabPanel
            value={value}
            index={
              props.nftData && props.nftData.nftSaleType === 'Auctioning'
                ? props.nftData.nftType === 'Audio'
                  ? 4
                  : 3
                : props.nftData && props.nftData.nftType === 'Audio'
                ? 3
                : 2
            }
          >
            <HistoryTab nftData={props.nftData} isMultiple={props.isMultiple} />
          </TabPanel>
        </div>
      </div>
      {showMusicTab && (
        <AudioPlayer
          nftData={props.nftData}
          artistDetails={props.artistDetails}
          audioInstance={audioInstance}
          setaudioPlaying={setaudioPlaying}
          setaudioIndex={setaudioIndex}
          audioIndex={audioIndex}
          audioPlayerMode={audioPlayerMode}
        />
      )}
    </>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

const AntTabs = withStyles({
  root: {
    borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    backgroundColor: '#1890ff',
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$selected': {
      color: '#1890ff',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#40a9ff',
      outline: 'none',
    },
  },
  selected: {},
}))((props) => (
  <Tab
    disableRipple
    {...props}
    style={{ minWidth: '72px', textTransform: 'none', marginRight: '30px' }}
  />
));

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: theme.spacing(3),
  },
}));
